/**
 * Mega Menu Carousel → Verticale su Mobile  (v4 — selettori corretti)
 * File: mega-menu-mobile-vertical.js
 *
 * Il tema usa custom HTML elements: xo-carousel-inner, xo-carousel-list,
 * xo-carousel-slide — NON classi CSS. Corretti tutti i querySelector.
 *
 * xo-carousel-inner ha display:grid !important nel CSS del tema.
 * Lo sovrascriviamo con display:block via style inline (priorità massima).
 * Il transform:translate3d viene iniettato inline da JS del tema su
 * xo-carousel-list — lo azzeriamo continuamente tramite MutationObserver.
 */

(function () {
  'use strict';

  var BREAKPOINT = 768;

  function isMobile() {
    return window.innerWidth < BREAKPOINT;
  }

  function fixCarousel() {
    if (!isMobile()) return;

    var container = document.querySelector('.mega-menu-1__carousel');
    if (!container) return;

    /* xo-carousel-inner: era display:grid !important ─────────── */
    container.querySelectorAll('xo-carousel-inner').forEach(function (el) {
      el.style.setProperty('display', 'block', 'important');
      el.style.setProperty('overflow', 'visible', 'important');
      el.style.setProperty('transform', 'none', 'important');
      el.style.setProperty('transition', 'none', 'important');
    });

    /* xo-carousel-list: ha il transform:translate3d inline ────── */
    container.querySelectorAll('xo-carousel-list').forEach(function (el) {
      el.style.setProperty('transform', 'none', 'important');
      el.style.setProperty('display', 'flex', 'important');
      el.style.setProperty('flex-direction', 'column', 'important');
      el.style.setProperty('overflow', 'visible', 'important');
      el.style.setProperty('width', '100%', 'important');
      el.style.setProperty('will-change', 'unset', 'important');
      el.style.setProperty('touch-action', 'auto', 'important');
    });

    /* xo-carousel-slide: forza visibilità su tutti gli slide ───── */
    container.querySelectorAll('xo-carousel-slide').forEach(function (el) {
      el.style.setProperty('width', '100%', 'important');
      el.style.setProperty('padding-inline-end', '0', 'important');
      el.style.setProperty('visibility', 'visible', 'important');
      el.style.setProperty('opacity', '1', 'important');
      el.style.setProperty('position', 'relative', 'important');
      el.style.setProperty('height', 'auto', 'important');
      el.style.setProperty('outline', 'none', 'important');
      el.style.setProperty('box-shadow', 'none', 'important');
      el.style.setProperty('border', 'none', 'important');
      el.removeAttribute('aria-hidden');
    });

    /* Rimuovi outline da hover: intercetta eventi touch/mouse ── */
    container.querySelectorAll('xo-carousel-slide').forEach(function (el) {
      if (el._outlineFixed) return;
      el._outlineFixed = true;
      ['mouseenter', 'mouseover', 'touchstart', 'pointerdown'].forEach(function (evt) {
        el.addEventListener(evt, function () {
          el.style.setProperty('outline', 'none', 'important');
        }, { passive: true });
      });
    });
  }

  /* MutationObserver: intercetta ogni aggiornamento inline di Alpine ── */
  var observer = new MutationObserver(function (mutations) {
    if (!isMobile()) return;
    var needsFix = false;
    mutations.forEach(function (m) {
      if (m.type === 'attributes' && m.attributeName === 'style') {
        var tag = m.target.tagName.toLowerCase();
        if (
          tag === 'xo-carousel-inner' ||
          tag === 'xo-carousel-list' ||
          tag === 'xo-carousel-slide'
        ) {
          needsFix = true;
        }
      }
    });
    if (needsFix) requestAnimationFrame(fixCarousel);
  });

  var resizeTimer;
  window.addEventListener('resize', function () {
    clearTimeout(resizeTimer);
    resizeTimer = setTimeout(fixCarousel, 100);
  });

  function init() {
    fixCarousel();

    observer.observe(document.body, {
      attributes:      true,
      subtree:         true,
      attributeFilter: ['style', 'aria-hidden'],
    });

    /* Retry per Alpine lazy-init del carousel */
    setTimeout(fixCarousel, 300);
    setTimeout(fixCarousel, 800);
    setTimeout(fixCarousel, 1500);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }

})();